module.exports = __webpack_public_path__ + "static/img/xuantou.c28434c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xuantou.png
// module id = 0909
// module chunks = 8